import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** The Split Dock's master pane (ADR-0007): the scene tree and its header. */
import { lazy, Suspense } from 'react';
import { SceneNodeCount } from './SceneStats.js';
import styles from './TscnPreviewShell.module.css';
// Lazy, so the panel stays out of the first canvas-paint bundle. `React.lazy`
// takes a default export, so the `.then` maps the named export to one.
const SceneTreeViewer = lazy(() => import('../SceneTreeViewer/SceneTreeViewer.js').then((m) => ({
    default: m.SceneTreeViewer,
})));
export function SceneTreePane({ sceneGraph, error, treeShare, onCollapse, onNodeReveal, onOpenSubScene, }) {
    // On an error, `<SceneTreeViewer>` with a null sceneGraph shows "Loading
    // scene…" and looks stuck. This message points at the error banner instead.
    let treeBody;
    if (error) {
        treeBody = (_jsx("div", { className: styles.emptyState, children: "No scene loaded \u2014 fix the parse error above to continue." }));
    }
    else if (sceneGraph === null) {
        treeBody = _jsx("div", { className: styles.loading, children: "Loading scene\u2026" });
    }
    else {
        treeBody = (_jsx(Suspense, { fallback: _jsx("div", { className: styles.loading, "aria-busy": "true", children: "Loading tree\u2026" }), children: _jsx(SceneTreeViewer, { onNodeReveal: onNodeReveal, onOpenSubScene: onOpenSubScene }) }));
    }
    return (_jsxs("div", { className: styles.masterPane, style: { '--tsi-pane-grow': treeShare }, children: [_jsxs("div", { className: styles.dockHeader, children: [_jsx("span", { className: styles.dockTitle, children: "Scene Tree" }), _jsx(SceneNodeCount, {}), _jsx("span", { className: styles.dockSpacer }), _jsx("button", { type: "button", className: `${styles.collapseButton} ${styles.wideOnly}`, onClick: onCollapse, title: "Collapse the side panel", "aria-label": "Collapse the side panel", children: "\u203A" })] }), _jsx("div", { className: styles.dockBody, children: _jsx("div", { className: styles.treePane, children: treeBody }) })] }));
}
//# sourceMappingURL=SceneTreePane.js.map